import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../../../shared/components';

@Component({
  selector: 'kbxl-agreements',
  templateUrl: './agreements.component.html',
  styleUrls: ['./agreements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgreementsComponent extends BaseComponent implements OnInit, OnDestroy {
  constructor(private route: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    this.route.params
      .pipe(
        map((params) => params.documentType),
        takeUntil(this.destroyed$)
      )
      .subscribe((documentType: string) => {
        if (documentType && documentType.toLowerCase() === 'privacy') {
          this.scrollToTarget('privacy');
        } else {
          this.scrollToTarget('terms');
        }
      });
  }

  scrollToTarget(id: string): void {
    const element = document.getElementById(id);

    if (element) {
      // set time out to allow UI to render view after navigation
      // otherwise both components will be on screen for a brief
      // moment when onInit fires and cause the scroll to get out of whack
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth' });
      }, 10);
    }
  }
}
